import { motion } from "framer-motion";
import steamRoomImg from "@/assets/steam_room_hammam.webp";
import drinksImg from "@/assets/drinks_hammam.webp";
import newCommonShowerImg from "@/assets/new_common_shower.png";
import newDarkRoomImg from "@/assets/new_dark_room.png";
import newDrinksBarImg from "@/assets/new_driniks_bar.png";
import newHugeJacuzziImg from "@/assets/new_huge_jacuzzi.png";

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero Section */}
      <section className="relative min-h-[50vh] overflow-hidden -mt-[72px] flex items-center">
        <img src="/hero_image_hammam.png" alt="About Hammam" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
          className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-20 w-full"
        >
          <div className="label-eyebrow mb-6 text-emerald-400 font-extrabold tracking-widest uppercase">Best Gay Spa in New Delhi</div>
          <h1 className="text-5xl lg:text-7xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-white via-amber-200 to-emerald-400 mb-6">
            About Hammam
          </h1>
          <p className="text-hsecondary text-lg max-w-2xl mt-4 leading-relaxed font-normal">
            Six centuries of ritual, reimagined for today's gentleman.
          </p>
        </motion.div>
      </section>

      {/* Our Roots, Vision & SEO Cards Section */}
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
            className="p-8 lg:p-10 rounded-2xl bg-gradient-to-b from-hpaper via-black/90 to-hpaper border-2 border-red-500/80 hover:border-red-400 shadow-xl shadow-red-950/30 transition-all duration-300 group"
          >
            <div className="text-xs uppercase tracking-[0.25em] text-red-400 font-extrabold mb-3">Heritage & Tradition</div>
            <h2 className="font-heading text-3xl text-red-400 font-bold mb-4">Our Roots</h2>
            <p className="text-base sm:text-lg leading-relaxed text-white/90 font-normal">
              Hammam represents the convergence of eastern bathing heritage and contemporary wellness craft. We don't believe in quick fixes. We believe in heat, time, oil, and clean water. Our spaces are built to feel ancient yet immaculate.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15, ease: [0.25, 1, 0.5, 1] }}
            className="p-8 lg:p-10 rounded-2xl bg-gradient-to-b from-hpaper via-black/90 to-hpaper border-2 border-emerald-400/80 hover:border-emerald-300 shadow-xl shadow-emerald-950/30 transition-all duration-300 group"
          >
            <div className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-extrabold mb-3">Future & Excellence</div>
            <h2 className="font-heading text-3xl text-emerald-400 font-bold mb-4">Vision</h2>
            <p className="text-base sm:text-lg leading-relaxed text-white/90 font-normal">
              To become India's most respected men's wellness brand — synonymous with discretion, craftsmanship and genuine hospitality. To open ten branches in the next five years without compromising a single detail.
            </p>
          </motion.div>

          {/* Card 3: Gay Spa Safe & Inclusive */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 1, 0.5, 1] }}
            className="p-8 lg:p-10 rounded-2xl bg-gradient-to-b from-hpaper via-black/90 to-hpaper border-2 border-amber-400/80 hover:border-amber-300 shadow-xl shadow-amber-950/30 transition-all duration-300 group"
          >
            <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-extrabold mb-3">Safe & Inclusive Spaces</div>
            <h2 className="font-heading text-3xl text-amber-400 font-bold mb-4">A Leading Gay Spa in Delhi</h2>
            <p className="text-sm sm:text-base leading-relaxed text-white/90 font-normal mb-3">
              Hammam Mens Spa is widely recognised as a safe and inclusive gay spa in Delhi, welcoming men from all backgrounds in a respectful and judgment-free environment. Privacy, consent, and comfort are at the core of our philosophy.
            </p>
            <p className="text-sm sm:text-base leading-relaxed text-white/90 font-normal">
              Our thoughtfully designed spaces include private therapy rooms as well as shared wellness areas, allowing guests to relax at their own pace. This commitment has made Hammam a trusted name combining luxury with professionalism.
            </p>
          </motion.div>

          {/* Card 4: World Class Facilities & Prime Locations */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.25, ease: [0.25, 1, 0.5, 1] }}
            className="p-8 lg:p-10 rounded-2xl bg-gradient-to-b from-hpaper via-black/90 to-hpaper border-2 border-rose-400/80 hover:border-rose-300 shadow-xl shadow-rose-950/30 transition-all duration-300 group flex flex-col justify-between"
          >
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-rose-400 font-extrabold mb-3">Infrastructure & Locations</div>
              <h2 className="font-heading text-3xl text-rose-400 font-bold mb-4">World-Class Facilities</h2>
              <p className="text-sm sm:text-base leading-relaxed text-white/90 font-normal mb-3">
                Each Hammam Mens Spa location offers premium infrastructure that elevates your spa journey:
              </p>
              <ul className="space-y-1.5 text-xs sm:text-sm text-white/90 font-normal mb-4">
                <li className="flex items-center gap-2"><span className="text-rose-400 font-bold">✓</span> Luxury & Heated Therapy Rooms</li>
                <li className="flex items-center gap-2"><span className="text-rose-400 font-bold">✓</span> Steam & Sauna Bath || Large & Sky Jacuzzi</li>
                <li className="flex items-center gap-2"><span className="text-rose-400 font-bold">✓</span> Discreet Dark Room & Modern Showers</li>
                <li className="flex items-center gap-2"><span className="text-rose-400 font-bold">✓</span> In-house Bar, Refreshments & Strict Hygiene</li>
              </ul>
            </div>
            <p className="text-xs sm:text-sm text-rose-300/90 font-semibold border-t border-white/10 pt-3">
              Locations: Lajpat Nagar (South Delhi) • Rajouri Garden (West Delhi) • Sikandarpur (Gurgaon)
            </p>
          </motion.div>
        </div>
      </div>

      {/* Divider Line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-hgold/40 to-transparent my-2 max-w-7xl mx-auto" />

      {/* Facilities Grid Section */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl lg:text-5xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-hgold to-emerald-400 mb-3">
            Our Elite. Discreet. Relaxing. Facilities
          </h2>
          <div className="text-xs uppercase tracking-[0.25em] text-emerald-400/90 font-bold">For The Modern Gentleman</div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            { img: steamRoomImg, title: "STEAM & SAUNA", border: "border-2 border-red-500 shadow-lg shadow-red-950/40" },
            { img: drinksImg, title: "SUNBATH AREA", border: "border-2 border-emerald-400 shadow-lg shadow-emerald-950/40" },
            { img: newHugeJacuzziImg, title: "HUGE JACUZZI", border: "border-2 border-amber-400 shadow-lg shadow-amber-950/40" },
            { img: newCommonShowerImg, title: "COMMON SHOWER", border: "border-2 border-rose-400 shadow-lg shadow-rose-950/40" },
            { img: newDarkRoomImg, title: "DISCREET DARK ROOM", border: "border-2 border-hgold shadow-lg shadow-yellow-950/40" },
            { img: newDrinksBarImg, title: "DRINKS & LOUNGE BAR", border: "border-2 border-cyan-400 shadow-lg shadow-cyan-950/40" }
          ].map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.1, ease: [0.25, 1, 0.5, 1] }}
              className={`relative rounded-2xl overflow-hidden ${item.border} group`}
            >
              <div className="aspect-square overflow-hidden bg-black/40">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
